import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../public/fonts/geist-mono-latin.woff2%22,%22weight%22:%22400%20500%22,%22style%22:%22normal%22}],%22display%22:%22swap%22,%22variable%22:%22--font-geist-mono%22,%22fallback%22:[%22ui-monospace%22,%22SF%20Mono%22,%22Menlo%22,%22monospace%22]}],%22variableName%22:%22geistMonoHome%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'geistMonoHome', 'geistMonoHome Fallback', ui-monospace, SF Mono, Menlo, monospace",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
